if (!customElements.get('purchase-assurance-dialog')) {
  customElements.define('purchase-assurance-dialog', class extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('dialog');
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      // Keep the underlying drawer's focus trap and Escape handler from
      // handling events belonging to this top-layer dialog.
      this.dialog.addEventListener('focusin', (event) => event.stopPropagation(), options);
      this.dialog.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') event.stopPropagation();
      }, options);
      document.addEventListener('click', (event) => {
        const trigger = event.target.closest('[data-purchase-assurance-open]');
        if (trigger?.getAttribute('aria-controls') !== this.dialog.id) return;
        this.opener = trigger;
        this.open();
      }, options);
      this.querySelector('[data-purchase-assurance-close]').addEventListener('click', () => this.dialog.close(), options);
      this.dialog.addEventListener('close', () => this.restore(), options);
      this.dialog.addEventListener('pointerdown', (event) => {
        this.backdropStart = this.isBackdrop(event);
      }, options);
      this.dialog.addEventListener('click', (event) => {
        if (this.backdropStart && this.isBackdrop(event)) this.dialog.close();
        this.backdropStart = false;
      }, options);
    }

    isBackdrop(event) {
      const rect = this.dialog.getBoundingClientRect();
      return event.target === this.dialog && (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom);
    }

    open() {
      if (this.dialog.open) return;
      this.scroll = { x: window.scrollX, y: window.scrollY };
      this.saved = ['position', 'top', 'left', 'width', 'overflow'].map((property) => [property, document.body.style.getPropertyValue(property), document.body.style.getPropertyPriority(property)]);
      document.body.style.position = 'fixed';
      document.body.style.top = `-${this.scroll.y}px`;
      document.body.style.left = `-${this.scroll.x}px`;
      document.body.style.width = '100%';
      document.body.style.overflow = 'hidden';
      this.dialog.showModal();
      try {
        (window.dataLayer = window.dataLayer || []).push({
          event: 'purchase_assurance_open',
          assurance_source: this.opener?.classList.contains('cart-drawer__assurance') ? 'cart_drawer' : 'product_page',
          page_path: window.location.pathname
        });
      } catch (error) { /* Analytics must never interrupt the guarantee dialog. */ }
    }

    restore() {
      if (!this.saved) return;
      for (const [property, value, priority] of this.saved) {
        if (value) document.body.style.setProperty(property, value, priority);
        else document.body.style.removeProperty(property);
      }
      this.saved = null;
      window.scrollTo({ left: this.scroll.x, top: this.scroll.y, behavior: 'instant' });
      if (this.opener?.isConnected) this.opener.focus({ preventScroll: true });
    }

    disconnectedCallback() {
      this.controller?.abort();
      if (this.dialog?.open) this.dialog.close();
      this.restore();
    }
  });
}
